import { useEffect, useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import useRegions from '../useRegions/useRegions'
import { getCustomsLineItems } from './helpers'
import { transformRequestEditItemsCustomsInfo } from './transformers'

const useCustomsInformation = ({
  storeId,
  resourceId,
  lineItems,
  setToastInfo,
  getCustomsInformationService,
  editCustomsInformationService,
  onGenerateLabel,
  includeRejectedItems,
}) => {
  const [showItemsCustomsInfoModal, setShowItemsCustomsInfoModal] = useState(false)
  const [lineItemsCustomsInfo, setLineItemsCustomsInfo] = useState([])

  const {
    data: itemsCustomsInfo,
    loading: loadingItemsCustomsInfo,
    fetchData: fetchItemsCustomsInfo,
  } = useFetch(() => getCustomsInformationService({ resourceId, storeId }), {
    doInitialRequest: false,
  })

  const { fetchData: editItemsCustomsInfo, loading: loadingEditItemsCustomsInfo } = useFetch(
    editCustomsInformationService,
    {
      doInitialRequest: false,
      transformRequest: transformRequestEditItemsCustomsInfo,
    }
  )

  const { regions, loading: loadingRegions, fetchData: fetchRegions } = useRegions({ doInitialRequest: false })

  useEffect(() => {
    if (showItemsCustomsInfoModal && lineItems.length > 0 && itemsCustomsInfo?.items?.length > 0) {
      setLineItemsCustomsInfo(getCustomsLineItems(lineItems, itemsCustomsInfo.items))
    }
  }, [lineItems, itemsCustomsInfo, showItemsCustomsInfoModal])

  const onChangeItemCustomsInfo = lineItemCustomsInfo => {
    const updatedItems = lineItemsCustomsInfo.map(lineItem => {
      if (lineItem.inventory_item_id === lineItemCustomsInfo.id) {
        return {
          ...lineItem,
          customsInfo: lineItemCustomsInfo,
        }
      }
      return lineItem
    })

    setLineItemsCustomsInfo(updatedItems)
  }

  const onConfirmItemsCustomsInfo = async () => {
    const itemsCustomsInfo = lineItemsCustomsInfo.map(item => ({
      ...item.customsInfo,
      country_code: item.customsInfo.country.code,
    }))

    try {
      await editItemsCustomsInfo({
        resourceId,
        storeId,
        items: itemsCustomsInfo,
      })

      await onGenerateLabel({ includeRejectedItems })
      setShowItemsCustomsInfoModal(false)
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  const openEditCustomsInformationModal = () => {
    setShowItemsCustomsInfoModal(true)
    fetchItemsCustomsInfo()
    fetchRegions()
  }

  const onCloseCustomsInformationModal = () => {
    setShowItemsCustomsInfoModal(false)
  }

  return {
    showItemsCustomsInfoModal,
    setShowItemsCustomsInfoModal,
    setLineItemsCustomsInfo,
    lineItemsCustomsInfo,
    fetchItemsCustomsInfo,
    loadingItemsCustomsInfo,
    loadingEditItemsCustomsInfo,
    onChangeItemCustomsInfo,
    onConfirmItemsCustomsInfo,
    openEditCustomsInformationModal,
    loadingRegions,
    regions,
    onCloseCustomsInformationModal,
  }
}

export default useCustomsInformation
